(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1127],{

/***/ 71127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_collection_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99886);
/* harmony import */ var _styles_collection_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_collection_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71911);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _data_home__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44330);










swiper__WEBPACK_IMPORTED_MODULE_3__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Navigation */ .W_,
    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Pagination */ .tl
]);
var Collection = function() {
    var settings = {
        dots: false,
        infinite: true,
        navigation: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0px",
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerPadding: "0px"
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerPadding: "0px"
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_styles_collection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().collection),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container-fluid",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_collection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().collectionheader),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: _data_home__WEBPACK_IMPORTED_MODULE_6__/* .homeLinks.collection.title */ .n.collection.title
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("fw-storyblock", {
                        channel: "senco",
                        playlist: "5zrla5",
                        autoplay: "true",
                        branding: "false"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_collection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().collection_slide_main_container),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_collection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().collectionheader),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_collection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().h2),
                                    children: "Explore our Collections"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "center-slider",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, settings), {
                                    children: _data_home__WEBPACK_IMPORTED_MODULE_6__/* .homeLinks.collection.sliders.map */ .n.collection.sliders.map(function(v, i) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                            href: v.link,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_collection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().collection_slide_item),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_styles_collection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().slide_img),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                            src: v.image,
                                                            className: "img-fluid",
                                                            alt: v.alt,
                                                            width: 460,
                                                            height: 608
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (_styles_collection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().port_text),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: (_styles_collection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().h3_sub),
                                                                children: v.name
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: (_styles_collection_module_scss__WEBPACK_IMPORTED_MODULE_7___default().port_btn),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                    className: "bi bi-arrow-right"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }, i);
                                    })
                                }))
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Collection);


/***/ }),

/***/ 99886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"collection":"collection_collection__0tK3m","collection_slide_main_container":"collection_collection_slide_main_container__eKBnu","collectionheader":"collection_collectionheader__Y2Cfk","h2":"collection_h2__4YXUO","slide_img":"collection_slide_img__gFouC","collection_slide_item":"collection_collection_slide_item__jxwQb","port_text":"collection_port_text__FXTWC","h3_sub":"collection_h3_sub__pHAgi","port_btn":"collection_port_btn__B2J4y","collection_image":"collection_collection_image__0e_Tj","slick-prev":"collection_slick-prev__w_1mg"};

/***/ })

}]);